"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var react_text_mask_1 = __importDefault(require("react-text-mask"));
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createInputRef = function (ref) {
            var inputRef = _this.props.inputRef;
            if (inputRef && typeof inputRef === 'function') {
                // @ts-ignore inputElement exists in Masked input. Issue in typings
                inputRef(ref ? ref.inputElement : null);
            }
        };
        return _this;
    }
    Input.prototype.render = function () {
        var _a = this.props, inputRef = _a.inputRef, keepCharPositions = _a.keepCharPositions, rest = __rest(_a, ["inputRef", "keepCharPositions"]);
        return this.props.mask ? (React.createElement(react_text_mask_1.default, __assign({}, rest, { ref: this.createInputRef, keepCharPositions: keepCharPositions }))) : (React.createElement("input", __assign({}, rest, { ref: inputRef })));
    };
    Input.propTypes = {
        mask: PropTypes.any,
        inputRef: PropTypes.func.isRequired,
    };
    return Input;
}(React.PureComponent));
exports.default = Input;
